import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { INR, titleCase } from "@/lib/format";
import { PageHeader, DataTable } from "@/components/shared";
import { payoutColumns } from "@/components/agent/PayoutPanels";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Coins } from "lucide-react";

export default function AgentPayouts() {
  const nav = useNavigate();
  const [status, setStatus] = useState("all");
  const [source, setSource] = useState("all");
  const [data, setData] = useState({ items: [], summary: {} });
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => {
    setLoading(true);
    const params = { ...(status !== "all" ? { status } : {}), ...(source !== "all" ? { source } : {}) };
    api.get("/agents/ledger/payouts", { params }).then(({ data }) => setData(data)).finally(() => setLoading(false));
  }, [status, source]);
  useEffect(() => { load(); }, [load]);
  const s = data.summary || {};
  const cards = [["Pending", s.pending], ["Approved (unpaid)", s.approved], ["Paid", s.paid], ["On hold", s.on_hold], ["TDS deducted", s.tds_total], ["GST on payouts", s.gst_total]];
  return (
    <div>
      <PageHeader title="Agent Payout Ledger" subtitle="All Insurance and Loan payouts across agents, by net payable" icon={Coins} />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-5">
        {cards.map(([l, v]) => (
          <div key={l} className="rounded-xl border border-border bg-card p-4">
            <div className="text-xs text-muted-foreground">{l}</div>
            <div className="text-lg font-bold mt-1" data-testid={`ledger-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{INR(v || 0)}</div>
          </div>
        ))}
      </div>
      <div className="flex gap-3 mb-4">
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-44" data-testid="ledger-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>{["all", "pending", "approved", "paid", "on_hold"].map((x) => <SelectItem key={x} value={x}>{x === "all" ? "All statuses" : titleCase(x)}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={source} onValueChange={setSource}>
          <SelectTrigger className="w-44" data-testid="ledger-source-filter"><SelectValue /></SelectTrigger>
          <SelectContent>{["all", "insurance", "loan"].map((x) => <SelectItem key={x} value={x}>{x === "all" ? "All lines" : titleCase(x)}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <DataTable columns={payoutColumns(load, true)} rows={data.items} loading={loading} rowTestId="ledger-payout-row"
        onRowClick={(p) => nav(`/agents/${p.agent_id}`)} emptyText="No payouts recorded yet" />
    </div>
  );
}
